import React from 'react'
import { useNavigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import MRDetails from './MRDetails'

const MRDetailsWrapper = () => {
    const MRDetailsLinkArray: Array<PageLink> = [
        {
            title: 'MR List',
            path: '/mr_list',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '>',
            path: '>',
            isSeparator: true,
            isActive: false,
        },   
    ]

    return (
        <>
            <PageTitle breadcrumbs={MRDetailsLinkArray}>MR Details</PageTitle>
            <MRDetails />
        </>
    )
}

export default MRDetailsWrapper